import { createSelector } from "reselect"
import { get } from "lodash"
import { computeFactorSensitivityContributors } from "./helper"

const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []

export const getPredictedFactorSensitivitySummary = state => get(state, "global.data.predictedFactorSensitivity.data.model.simulation.predictedFactorSensitivity.0", EMPTY_OBJECT)
export const getRebalancedPredictedFactorSensitivitySummary = state => get(state, "modules.rebalance.rebalancedPredictedFactorSensitivity.0", EMPTY_ARRAY)

// Contributors
const getRawPredictedFactorSensitivityContributors = state => get(state, "global.data.predictedFactorSensitivityContributors.data.model.simulation.predictedFactorSensitivityContributors", EMPTY_ARRAY)
const getRawRebalancedPredictedFactorSensitivityContributors = state => get(state, "modules.rebalance.rebalancedPredictedFactorSensitivityContributors", EMPTY_ARRAY)

// Grouped Contributors
const getRawGroupedPredictedFactorSensitivityContributors = state => get(state, "global.data.groupedPredictedFactorSensitivityContributors.data.model.simulation.groupedPredictedFactorSensitivityContributors", EMPTY_ARRAY)
const getRawGroupedRebalancedPredictedFactorSensitivityContributors = state => get(state, "modules.rebalance.rebalancedGroupedPredictedFactorSensitivityContributors", EMPTY_ARRAY)

export const getPredictedFactorSensitivityContributors = createSelector(
  [getRawPredictedFactorSensitivityContributors],
  computeFactorSensitivityContributors,
)

export const getGroupedPredictedFactorSensitivityContributors = createSelector(
  [getRawGroupedPredictedFactorSensitivityContributors],
  computeFactorSensitivityContributors,
)

export const getRebalancedPredictedFactorSensitivityContributors = createSelector(
  [getRawRebalancedPredictedFactorSensitivityContributors],
  computeFactorSensitivityContributors,
)

export const getGroupedRebalancedPredictedFactorSensitivityContributors = createSelector(
  [getRawGroupedRebalancedPredictedFactorSensitivityContributors],
  computeFactorSensitivityContributors,
)
